/*
  Cubitt: popup de Halloween (sections/cubitt-halloween-popup.liquid). Aparece a los N segundos, como mucho una vez
  cada N días por navegador (localStorage), y lleva al juego: si la home tiene la sección del juego, lo abre ahí mismo;
  si no, el enlace va a la home con ?hw=jugar y el juego se abre solo. No sale si el juego ya está abierto.
*/
const STORAGE_KEY = 'cubitt-hw-popup';

class CubittHalloweenPopup extends HTMLElement {
  connectedCallback() {
    if (this._ready) return;
    this._ready = true;

    this.querySelectorAll('[data-hwp-close]').forEach((el) => el.addEventListener('click', () => this.close()));
    this.querySelector('[data-hwp-play]').addEventListener('click', (event) => {
      const game = document.querySelector('cubitt-halloween-game');
      this.close();
      if (game && typeof game.open === 'function') {
        event.preventDefault();
        game._byKeyboard = event.detail === 0;
        game.open();
      }
    });
    this._onKey = (event) => {
      if (event.key === 'Escape') this.close();
    };

    // En el editor se ve al seleccionar la sección, sin esperar ni recordar que ya salió.
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:select', (event) => {
        if (event.target.contains(this)) this.show(false);
      });
      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.target.contains(this)) this.close();
      });
      return;
    }

    if (new URLSearchParams(window.location.search).get('hw') === 'jugar') return;
    const days = Number(this.dataset.days);
    if (days > 0) {
      let last = 0;
      try {
        last = Number(window.localStorage.getItem(STORAGE_KEY)) || 0;
      } catch (e) {}
      if (Date.now() - last < days * 86400000) return;
    }
    window.setTimeout(() => this.show(true), (Number(this.dataset.delay) || 0) * 1000);
  }

  async show(remember) {
    // Si el juego ya está abierto (o se abrió mientras tanto), no se interrumpe.
    if (document.documentElement.classList.contains('cubitt-hw-lock')) return;
    const img = this.querySelector('img');
    if (img) {
      img.loading = 'eager';
      try {
        await img.decode();
      } catch (e) {}
    }
    this._lastFocus = document.activeElement;
    this.hidden = false;
    window.requestAnimationFrame(() => this.classList.add('is-open'));
    document.documentElement.classList.add('cubitt-hwp-lock');
    document.addEventListener('keydown', this._onKey);
    // El foco va al cuadro (sin contorno): con Tab se llega a la imagen y a cerrar.
    this.querySelector('.cubitt-hwp__dialog').focus({ preventScroll: true });
    if (remember) {
      try {
        window.localStorage.setItem(STORAGE_KEY, String(Date.now()));
      } catch (e) {}
    }
  }

  close() {
    if (this.hidden) return;
    this.classList.remove('is-open');
    this.hidden = true;
    document.documentElement.classList.remove('cubitt-hwp-lock');
    document.removeEventListener('keydown', this._onKey);
    if (this._lastFocus && this._lastFocus.focus && document.contains(this._lastFocus)) {
      this._lastFocus.focus({ preventScroll: true });
    }
  }
}

if (!customElements.get('cubitt-halloween-popup')) customElements.define('cubitt-halloween-popup', CubittHalloweenPopup);
